<template>
  <!--
      作者：gmshop
      时间：2019-10-25
      描述：订单详情
  -->
  <div class="pb50" v-loading="loading">
    <!--内容-->
    <div class="product-content">
      <!--基本信息-->
      <div class="common-form">基本信息</div>
      <div class="table-wrap">
        <el-row>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">订单号：</span>
              {{ detail.order_no }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">买家：</span>
              {{ detail.user.nickName }}
              <span>用户ID：({{ detail.user.user_id }})</span>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">订单金额 (元)：</span>
              {{ detail.order_price }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">运费金额 (元)：</span>
              {{ detail.express_price }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16" v-if="detail.coupon_money > 0">
              <span class="gray9">优惠券抵扣 (元)：</span>
              {{ detail.coupon_money }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16" v-if="detail.points_money > 0">
              <span class="gray9">积分抵扣 (元)：</span>
              {{ detail.points_money }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16 " v-if="detail.points_num > 0">
              <span class="gray9">使用积分：</span>
              {{ detail.points_num }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16" v-if="detail.fullreduce_money > 0">
              <span class="gray9">满减金额 (元)：</span>
              {{ detail.fullreduce_money }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">实付款金额 (元)：</span>
              {{ detail.pay_price }}
            </div>
          </el-col>

          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">随机立减 (元)：</span>
              {{ detail.random_reduce_money }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">支付方式：</span>
              {{ detail.pay_type.text }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">配送方式：</span>
              {{ detail.delivery_type.text }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">交易状态：</span>
              {{ detail.order_status.text }}
            </div>
          </el-col>
          <el-col :span="5" v-if="detail.cancel_time">
            <div class="pb16">
              <span class="gray9">取消时间：</span>
              {{ detail.cancel_time }}
            </div>
          </el-col>
          <el-col :span="5" v-if="detail['pay_status']['value'] == 10 && detail['order_status']['value'] == 10 && detail['order_source'] == 10" v-auth="'/order/order/updatePrice'">
            <el-button @click="editClick(detail, 'edit')" size="small">修改价格</el-button>
          </el-col>
        </el-row>
      </div>
      <!--编辑-->
      <Add v-if="open_dialog.edit" :open_edit="open_dialog.edit" :order="userModel" @close="closeDialogFunc($event, 'edit')"></Add>
      <!--商品信息-->
      <div class="common-form mt16" v-if="detail.pay_type.value == 60">付款凭证支付信息</div>
      <div class="table-wrap">
        <el-row>
          <el-col :span="5" v-if="detail.pay_type.value == 60">
            <div class="pb16">
              <span class="gray9">付款凭证状态：</span>
              {{ detail.pay_image_status.text }}
            </div>
          </el-col>

          </el-row>
          <el-row>
          <el-col :span="25" v-if="detail.pay_type.value == 60">
            <div class="pb16">
              <span class="gray9">付款凭证图片：</span>

              <div class="draggable-list">
                <draggable class="wrapper" v-model="detail.pay_image_url">
                  <transition-group>
                    <div class="item" v-for="(item, index) in detail.pay_image_url" :key="item">

                      <el-image

                         :src="item"
                         :preview-src-list="[item]">
                      </el-image>

                    </div>
                  </transition-group>
                </draggable>

              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!--商品信息-->
      <div class="common-form mt16">商品信息</div>
      <div class="table-wrap">
        <el-table size="small" :data="detail.product" border style="width: 100%">
          <el-table-column prop="product_name" label="商品" width="400">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.image.file_path" /></div>
                <div class="info">
                  <div class="name">{{ scope.row.product_name }}</div>
                  <div class="gray9" v-if="scope.row.product_attr!=''">{{scope.row.product_attr}}</div>
                  <div class="orange" v-if="scope.row.refund">{{ scope.row.refund.type.text }}-{{ scope.row.refund.status.text }}</div>
                  <div class="price">
                    <span :class="{'text-d-line':scope.row.is_user_grade==1,'gray6':scope.row.is_user_grade!=1}">￥ {{ scope.row.product_price }}</span>
                    <span class="ml10" v-if="scope.row.is_user_grade==1">
                      会员折扣价：￥ {{ scope.row.grade_product_price }}
                    </span>
                  </div>
                  <div class="orange">结算类型：{{ scope.row.ml_type==1?"正常结算":"特殊定向" }}</div>
                  <div class="orange">{{ scope.row.is_agri==1?"农产品":"" }}</div>
                </div>
              </div>
            </template>

          </el-table-column>
          <el-table-column prop="supplier.company_name" label="供应商"></el-table-column>
          <el-table-column prop="product_no" label="商品编码"></el-table-column>
          <el-table-column prop="product_weight" label="重量 (Kg)"></el-table-column>
          <el-table-column prop="total_num" label="购买数量">
            <template slot-scope="scope">
              <p>x {{ scope.row.total_num }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="points_money" label="积分抵扣金额">
            <template slot-scope="scope">
              <p>￥ {{ scope.row.points_money }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="points_num" label="积分抵扣数量">
            <template slot-scope="scope">
              <p>{{ scope.row.points_num }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="total_price" label="商品总价(元)">
            <template slot-scope="scope">
              <p>￥ {{ scope.row.total_price }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="total_pay_price" label="实际支付金额(元)">
            <template slot-scope="scope">
              <p>￥ {{ scope.row.total_pay_price }}</p>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--收货信息-->
      <div v-if="(detail.delivery_type.value == 10 || detail.delivery_type.value == 50)">
        <div class="common-form mt16 d-s-c">收货信息
          <div class="ml10">
            <el-button size="small" type="primary" icon="el-icon-edit-outline" @click="editClick(detail, 'address')" v-if="detail.pay_status.value == 20 && detail.delivery_status.value == 10" v-auth="'/order/order/updateAddress'">编辑</el-button>
          </div>
        </div>
        <!--编辑-->
        <Address v-if="open_dialog.address" :detail="detail" @close="closeDialogFunc($event, 'address')"></Address>
        <div class="table-wrap">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">收货人：</span>
                {{ detail.address.name }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">收货电话：</span>
                {{ detail.address.phone }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">收货地址：</span>
                {{ detail.address.region.province }} {{ detail.address.region.city }} {{ detail.address.region.region }} {{ detail.address.detail }} {{ detail.address.street_numbers }}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="25">
              <div class="pb16">
                <span class="gray9">买家留言：</span>
                {{ detail.buyer_remark }}
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <div v-if="detail.is_custom == 1">
        <div class="common-form mt16 d-s-c">定制信息</div>
        <!--编辑-->
        <div class="table-wrap">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">送给：</span>
                {{ detail.give_name }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">想对他(她)说：</span>
                <el-input type="textarea" v-model="detail.give_content" class="max-w460" disabled="true" rows="4"></el-input>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">我是：</span>
                {{ detail.my_name }}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="25">
              <div class="pb16">
                <span class="gray9">日期：</span>
                {{ detail.give_date }}
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!--自提门店信息-->
      <template v-if="(detail.delivery_type.value == 20 || detail.delivery_type.value == 60)">
        <div class="common-form mt16">自提用户信息</div>
        <div class="table-wrap" v-if="detail.extract">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">联系人：</span>
                {{ detail.extract.linkman }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">联系电话：</span>
                {{ detail.extract.phone }}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="25">
              <div class="pb16">
                <span class="gray9">备注：</span>
                {{ detail.buyer_remark }}
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="common-form mt16">自提信息</div>
        <div class="table-wrap" v-if="detail.extract">
          <el-row>
            <el-col :span="5" v-if="detail.delivery_type.value == 20">
              <div class="pb16">
                <span class="gray9">门店ID：</span>
                {{ detail.extractStore.store_id }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">门店名称：</span>
                {{ detail.extractStore.store_name }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">联系人：</span>
                {{ detail.extractStore.linkman }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">联系电话：</span>
                {{ detail.extractStore.phone }}
              </div>
            </el-col>
            <el-col :span="15" v-if="detail.delivery_type.value == 20">
              <div class="pb16">
                <span class="gray9">门店地址：</span>
                {{ detail.extractStore.region.province }}- {{ detail.extractStore.region.city }}- {{ detail.extractStore.region.region }}-
                {{ detail.extractStore.address }}
              </div>
            </el-col>
            <el-col :span="15" v-if="detail.delivery_type.value == 60">
              <div class="pb16">
                <span class="gray9">门店地址：</span>
                {{ detail.extractStore.address }}
              </div>
            </el-col>
          </el-row>
        </div>
      </template>

      <!--无需发货-->
      <template v-if="detail.delivery_type.value == 30">
        <div class="common-form mt16">用户信息</div>
        <div class="table-wrap">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">联系手机：</span>
                {{ detail.user.mobile }}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="25">
              <div class="pb16">
                <span class="gray9">备注：</span>
                {{ detail.buyer_remark }}
              </div>
            </el-col>
          </el-row>
        </div>
      </template>

      <!--付款信息-->
      <div class="table-wrap" v-if="detail.pay_status.value == 20">
        <div class="common-form mt16">付款信息</div>
        <div class="table-wrap">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">应付款金额：</span>
                {{ detail.pay_price }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">支付方式：</span>
                {{ detail.pay_type.text }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">支付流水号：</span>
                {{ detail.transaction_id }}
              </div>
            </el-col>
            <el-col :span="5" v-if="detail.pay_type.value != 50">
              <div class="pb16">
                <span class="gray9">付款状态：</span>
                {{ detail.pay_status.text }}
              </div>
            </el-col>
            <el-col :span="5" v-if="detail.pay_type.value != 50">
              <div class="pb16">
                <span class="gray9">付款时间：</span>
                {{ detail.pay_time }}
              </div>
            </el-col>
            <el-col :span="5" v-if="detail.pay_type.value == 50">
              <div class="pb16">
                <span class="gray9">付款状态：</span>
                {{ detail.delivery_pay_status.text }}
              </div>
            </el-col>
            <el-col :span="5" v-if="detail.pay_type.value == 50">
              <div class="pb16">
                <span class="gray9">付款时间：</span>
                {{ detail.delivery_pay_time }}
              </div>
            </el-col>

            </el-row>

        </div>
      </div>

      <!--  用户取消订单 -->
      <div v-if="detail.pay_status.value == 20 && detail.order_status.value == 21" v-auth="'/order/operate/confirmCancel'">
        <div class="common-form mt16">用户取消订单</div>
        <p class="red pb16">当前买家已付款并申请取消订单，请审核是否同意，如同意则自动退回付款金额（微信支付原路退款）并关闭订单。</p>
        <el-form size="small" ref="forms" :model="forms">
          <el-form-item label="审核状态">
            <div>
              <el-radio v-model="forms.is_cancel" :label="1">同意</el-radio>
              <el-radio v-model="forms.is_cancel" :label="0">拒绝</el-radio>
            </div>
          </el-form-item>
          <el-form-item label="拒绝原因" v-if="forms.is_cancel < 1">
            <el-input v-model="forms.cancel_reject_desc" class="max-w460"></el-input>
          </el-form-item>
          <el-form-item label="退款金额">
            <el-input v-model="forms.refund_money" class="max-w460"></el-input>
          </el-form-item>

          <el-form-item><el-button type="primary" @click="confirmCancel()">确认审核</el-button></el-form-item>
        </el-form>
      </div>

      <!--发货信息-->
      <div v-if="detail.pay_status.value == 20 && detail.delivery_type.value == 10 && [20, 21].indexOf(detail.order_status.value) === -1" v-auth="'/order/order/delivery'">
        <Express v-if="open_dialog.partExpress" :dataModel="detail" @closeDialog="closeDialogFunc($event, 'partExpress')"></Express>
        <div v-if="detail.delivery_status.value == 10 && detail.shipment_type == 1">
          <!-- 去发货 -->
          <div class="common-form mt16">去发货</div>
          <el-form size="small" ref="form" :model="form" label-width="100px">
            <el-form-item label="物流公司">
              <el-select v-model="form.express_id" placeholder="请选择快递公司">
                <el-option :label="item.express_name" v-for="(item, index) in expressList" :key="index" :value="item.express_id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="物流单号">
              <el-input v-model="form.express_no" class="max-w460"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div v-else>
          <div v-if="detail.shipment_type == 1">
            <div class="common-form mt16 d-s-c">
              <span>发货信息</span>
              <div class="ml10">
              <el-button size="small" type="primary" icon="el-icon-edit-outline" @click="editClick(detail, 'express')" v-if="detail.pay_status.value == 20 && detail.delivery_status.value == 20 && detail.receipt_status.value == 10" v-auth="'/order/order/updateExpress'">编辑</el-button>
              <el-button class="ml10" size="small" type="primary" icon="el-icon-truck" @click="editClick(detail, 'track')" v-if="detail.pay_status.value == 20 && detail.delivery_status.value == 20" v-auth="'/order/express/track'">物流轨迹</el-button>
              </div>
            </div>
            <div class="table-wrap">
              <el-row>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">物流公司：</span>
                    {{ detail.express.express_name }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">物流单号：</span>
                    {{ detail.express_no }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">发货状态：</span>
                    {{ detail.delivery_status.text }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">发货时间：</span>
                    {{ detail.delivery_time }}
                  </div>
                </el-col>
              </el-row>
            </div>
            <!--编辑-->
            <UpdateExpress v-if="open_dialog.express" :expressList="expressList" :detail="detail" :part_express="part_express" @close="closeDialogFunc($event, 'express')"></UpdateExpress>
            <!--轨迹-->
            <Track v-if="open_dialog.track" :dataModel="detail" :part_express="part_express" @close="closeDialogFunc($event, 'track')" />
          </div>
          <div v-else>
            <div v-for="(item, index) in detail.orderExpress" :key="index">
              <div class="common-form mt16 d-s-c">
                <span>发货信息</span>
                <div class="ml10">
                <el-button size="small" type="primary" icon="el-icon-edit-outline" @click="editClickSecond(detail, 'express',item)" v-if="detail.pay_status.value == 20 && detail.receipt_status.value == 10" v-auth="'/order/order/updateExpress'">编辑</el-button>
                <el-button class="ml10" size="small" type="primary" icon="el-icon-truck" @click="editClickSecond(detail, 'track',item)" v-if="detail.pay_status.value == 20" v-auth="'/order/express/track'">物流轨迹</el-button>
                </div>
              </div>
              <div class="table-wrap">
                <el-row>
                  <el-col :span="5">
                    <div class="pb16">
                      <span class="gray9">物流公司：</span>
                      {{ item.express.express_name }}
                    </div>
                  </el-col>
                  <el-col :span="5">
                    <div class="pb16">
                      <span class="gray9">物流单号：</span>
                      {{ item.express_no }}
                    </div>
                  </el-col>
                  <el-col :span="5">
                    <div class="pb16">
                      <span class="gray9">发货状态：</span>
                      已发货
                    </div>
                  </el-col>
                  <el-col :span="5">
                    <div class="pb16">
                      <span class="gray9">发货时间：</span>
                      {{ item.delivery_time }}
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
            <!--编辑-->
            <UpdateExpress v-if="open_dialog.express" :expressList="expressList" :detail="detail" :part_express="part_express" @close="closeDialogFunc($event, 'express')"></UpdateExpress>
            <!--轨迹-->
            <Track v-if="open_dialog.track" :dataModel="detail" :part_express="part_express" @close="closeDialogFunc($event, 'track')" />
          </div>
        </div>
      </div>
      <!--门店自提核销-->
      <div v-if="(detail.delivery_type.value == 20 || detail.delivery_type.value == 60) && detail.pay_status.value == 20 && detail.order_status.value != 21 && detail.order_status.value != 20" v-auth="'/order/operate/extract'">
        <div class="common-form mt16">门店自提核销</div>
        <div v-if="detail.delivery_status.value == 10">
          <el-form size="small" ref="extract_form" :model="extract_form" label-width="100px">
            <el-form-item label="门店核销员">
              <el-select v-model="extract_form.order.extract_clerk_id" placeholder="点击选择" v-if="detail.delivery_type.value == 20">
                  <el-option :label="item.real_name" v-for="(item, index) in shopClerkList" :key="index" :value="item.clerk_id"></el-option>
                </el-select>
                <el-select v-model="extract_form.order.extract_clerk_id" placeholder="点击选择" v-if="detail.delivery_type.value == 60">
                  <el-option :label="item.real_name" v-for="(item, index) in shopClerkList" :key="index" :value="item.is_store_clerk_id"></el-option>
                </el-select>
              </el-form-item>
            </el-form-item>
            <el-form-item label="买家取货状态 ">
              <el-radio v-model="extract_form.order.extract_status" :label="1">已取货</el-radio>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onExtract(detail.order_id)">确认核销</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div v-else class="table-wrap">
          <template v-if="detail.extractClerk">
            <el-row>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">自提门店名称：</span>
                  {{ detail.extractStore.store_name }}
                </div>
              </el-col>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">核销员：</span>
                  {{ detail.extractClerk.real_name }}
                </div>
              </el-col>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">核销状态：</span>
                  <template v-if="detail.delivery_status.value == 20">
                    已核销
                  </template>
                </div>
              </el-col>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">核销时间：</span>
                  {{ detail.delivery_time }}
                </div>
              </el-col>
            </el-row>
          </template>
        </div>
      </div>
    </div>

    <!--分佣信息-->
    <div class="common-form mt16" v-if="detail.agent_log && detail.agent_log.length">分佣信息</div>
    <div class="table-wrap agent_log" v-if="detail.agent_log && detail.agent_log.length">
      <el-table size="small" :data="detail.agent_log" border style="width: 100%">
        <el-table-column prop="log_type.text" label="类型"></el-table-column>
        <el-table-column prop="user" label="用户">
          <template slot-scope="scope">
            <div class="user d-s-c d-r">
              <div class="pic"><img v-img-url="scope.row.user.avatarUrl" width="40" height="40" /></div>
              <div class="ml10">
                <div class="name">{{ scope.row.user.nickName }} ({{ scope.row.user.user_id }})</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="佣金"></el-table-column>
        <el-table-column prop="point" label="积分" v-auth="'/plus/agent/point'"></el-table-column>
        <el-table-column prop="is_settled" label="结算状态">
          <template slot-scope="scope">
            <span v-if="scope.row.is_settled==1" class="green">已结算</span>
            <span v-if="scope.row.is_settled==0"  class="gray9">未结算</span>
            <span v-if="scope.row.is_settled==2"  class="gray9">订单取消</span>
          </template>
        </el-table-column>
        <el-table-column prop="settle_time" label="结算时间"></el-table-column>
      </el-table>
    </div>

    <div class="common-button-wrapper">
      <el-button size="small" type="info" @click="cancelFunc">返回上一页</el-button>
      <!--确认发货-->
      <template v-if="detail.erp_status==0 && detail.pay_status.value == 20 && detail.delivery_type.value == 10 && [20, 21].indexOf(detail.order_status.value) === -1">
        <el-button size="small" type="primary" @click="onSubmit" v-if="detail.delivery_status.value == 10&&detail.shipment_type == 1">确认发货</el-button>
        <el-button size="small" type="primary" @click="editClick(detail, 'partExpress')" v-if="detail.delivery_status.value == 10&&detail.shipment_type == 2">分包发货</el-button>
      </template>
      <!--确认收货-->
      <template v-if="detail.pay_status.value == 20 && detail.delivery_status.value == 20 &&  detail.receipt_status.value == 10 && [20, 21].indexOf(detail.order_status.value) === -1">
        <el-button size="small" type="primary" @click="onReceipt" v-if=" detail.receipt_status.value == 10 ">确认收货</el-button>
      </template>

      <!--用户取消-->
      <!-- <template v-if="detail.pay_status.value == 20 && detail.order_status.value == 21">
        <el-button size="small" type="primary" @click="confirmCancel()">确认审核</el-button>
      </template> -->
    </div>
  </div>
</template>

<script>
  import OrderApi from '@/api/order.js';
  import Add from './dialog/Add.vue';
  import UpdateExpress from './dialog/updateExpress.vue';
  import Address from './dialog/Address.vue';
  import Track from './dialog/Track.vue';
  import draggable from 'vuedraggable';
  import Upload from '@/components/file/Upload';
  import Express from './dialog/Express.vue';
  import {
    deepClone
  } from '@/utils/base.js';
  export default {
    components: {
      /*快速发货*/
      Express,
      Add,
      UpdateExpress,
      Address,
      Track,
      draggable,
      Upload
    },
    data() {
      return {
        active: 0,
        /*是否加载完成*/
        loading: true,
        /*订单数据*/
        detail: {
          pay_status: [],
          pay_type: [],
          delivery_type: [],
          user: {},
          address: [],
          product: [],
          order_status: [],
          extract: [],
          extract_store: [],
          express: [],
          delivery_status: [],
          extractClerk: [],
          pay_image_log:[]
        },
        /*是否打开添加弹窗*/
        open_add: false,
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*发货*/
        form: {
          /*订单ID*/
          express_id: null,
          /*订单号*/
          express_no: ''
        },
        forms: {
          refund_money:0,
          is_cancel: 1,
          cancel_reject_desc:''
        },
        extract_form: {
          order: {
            extract_status: 1
          }
        },
        order: {},
        delivery_type: 0,
        /*配送方式*/
        exStyle: [],
        /*门店列表*/
        shopList: [],
        /*当前编辑的对象*/
        userModel: {},
        /*时间*/
        create_time: '',
        /*快递公司列表*/
        expressList: [],
        shopClerkList: [],
        /*是否打开编辑弹窗*/
        open_dialog: {
          edit: false,
          express: false,
          partExpress: false,
          address: false,
          track: false,
          refund: false,
        },
        part_express: {
          express_id:0,
          express_no:''
        },
      };
    },
    created() {
      /*获取列表*/
      this.getParams();
    },
    methods: {
      next() {
        if (this.active++ > 4) this.active = 0;
      },
      /*获取参数*/
      getParams() {
        let self = this;
        // 取到路由带过来的参数
        const params = this.$route.query.order_id;
        OrderApi.orderdetail({
              order_id: params
            },
            true
          )
          .then(data => {
            self.loading = false;
            self.detail = data.data.detail;
            if (self.detail.delivery_type.value == 60) {
              self.detail.extract.linkman = self.detail.user.nickName;
              self.detail.extract.phone = self.detail.user.mobile;
              self.detail.extractStore = data.data.extract;
            }
            self.forms.refund_money = data.data.detail.pay_price;
            self.expressList = data.data.expressList;
            self.shopClerkList = data.data.shopClerkList;
          })
          .catch(error => {
            self.loading = false;
          });
      },

      /*发货*/
      onSubmit() {
        let self = this;
        let param = self.form;
        if (param.express_id == null) {
          this.$message.error('请选择物流公司');
          return;
        }
        if (param.express_no == '') {
          this.$message.error('请填写物流单号');
          return;
        }
        let order_id = this.$route.query.order_id;
        OrderApi.delivery({
              param: param,
              order_id: order_id
            },
            true
          )
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，发货成功',
              type: 'success'
            });
            self.getParams();
          })
          .catch(error => {
            self.loading = false;
          });
      },

      /*确认取消*/
      confirmCancel() {
        let self = this;
        let order_id = this.$route.query.order_id;
        let is_cancel = self.forms.is_cancel;
        let refund_money = self.forms.refund_money;
        let cancel_reject_desc = self.forms.cancel_reject_desc;
        self.$confirm('确认当前操作吗。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.loading = true;
          OrderApi.confirm({
              order_id: order_id,
              refund_money: refund_money,
              is_cancel: is_cancel,
              cancel_reject_desc:cancel_reject_desc
            },
            true
          )
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，审核成功',
              type: 'success'
            });
            self.getParams();
          })
          .catch(error => {
            self.loading = false;
          });
        }).catch(() => {});

      },

      /*核销*/
      onExtract(e) {
        let self = this;
        let extract_form = self.extract_form;
        extract_form.order_id = e;
        OrderApi.extract({
              extract_form
            },
            true
          )
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，操作成功',
              type: 'success'
            });
            self.getParams();
          })
          .catch(error => {
            self.loading = false;
          });
      },

      /*打开编辑*/
      editClick(item, type) {
        this.userModel = deepClone(item);
        this.open_dialog[type] = true;
      },

      /*打开编辑二*/
      editClickSecond(item, type, data) {
        this.part_express.express_id = data.express_id
        this.part_express.express_no = data.express_no
        this.userModel = deepClone(item);
        this.open_dialog[type] = true;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        this.open_dialog[f] = e.openDialog;
        this.getParams();
      },

      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      },
      /*收货*/
      onReceipt(){
        let self = this;
        let order_id = this.$route.query.order_id;
        OrderApi.orderReceipt({
              order_id: order_id
            },
            true
          )
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，收货成功',
              type: 'success'
            });
            self.getParams();
          })
          .catch(error => {
            self.loading = false;
          });
      },


    }
  };
</script>
<style>


  .draggable-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .draggable-list .wrapper > span {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .draggable-list .item {
    position: relative;
    width: 110px;
    height: 110px;
    margin-top: 10px;
    margin-right: 10px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #dddddd;
  }

  .draggable-list .delete-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
    background: red;
    line-height: 16px;
    font-size: 16px;
    color: #ffffff;
    display: none;
  }

  .draggable-list .item:hover .delete-btn {
    display: block;
  }

  .draggable-list .item  el-image{
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-height: 100%;
    max-width: 100%;
  }

  .draggable-list .img-select {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #dddddd;
    font-size: 30px;
  }

  .draggable-list .img-select i {
    color: #409eff;
  }
</style>



// WEBPACK FOOTER //
// src/views/order/order/detail.vue